<template>
    <div class="remove-ftr-main">
        <div class="remove-ftr-con">
            <PrimeButton @click="emit('closeDialog')" label="Cancel" variant="secondary" class="p-btn-root_secondary" />
            <PrimeButton @click="handleBlock" label="Remove" variant="error" class="p-btn-root_error" :loading="removeLoader" />
        </div>
    </div>
</template>
<script setup lang="ts">
import { ModalNames } from '~/types/modals';

import { useContactsStore } from '~/stores/person/contacts';

const contactStore = useContactsStore();
const emit = defineEmits(['closeDialog']);

const dialogRef =   getDialogRef(ModalNames.REMOVE_CONTACT);
const removeLoader = ref(false);

// For now same logic as block contact
const handleBlock = () => {
    //remove simulation
    // removeLoader.value = true;

    // setTimeout(() => {
    //     if (contactStore.selectedContact) {
    //         contactStore.selectedContact.blocked = false;
    //         contactStore.removeContact(contactStore.selectedContact.id);
    //     }
    //     removeLoader.value = false;
    //     emit('closeDialog');
    // }, 3000);
};
</script>
<style lang="scss" scoped>
.remove-ftr-main {
    display: flex;
    padding-top: 32px;
    flex-direction: column;
    align-items: flex-end;
    align-self: stretch;

    .remove-ftr-con {
        display: flex;
        padding: 0px 24px 24px 24px;
        justify-content: flex-end;
        align-items: flex-start;
        gap: 12px;
        align-self: stretch;
    }
}
</style>
